<div id="infra">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="card shadow-lg inner-card">
                  <h4 class="card-title text-center">Campus</h4>
                  <div class="card-body">
                      <div class="row">
                        <div class="col-12 col-md-6 mb-4 text-center" *ngFor="let img of imgUrl;">
                            <a href="{{img}}" data-lightbox="Campus"><img [src]="img" alt="Campus" class="img-fluid rounded"></a>
                        </div>
                      </div>
                  </div>
              </div>

          </div>
      </div>

     
  </div>
</div>